
export {
    Message,
    MakeConfigMessage,
    MakeUploadMessage,
};



const Message = {}

Object.defineProperties(Message, {
    CONFIG : { value: 'CONFIG', writable:false },
    UPLOAD : { value: 'UPLOAD', writable:false },
    ABORT_UPLOAD : { value: 'ABORT_UPLOAD', writable:false },
});


const MakeUploadMessage = (token) => {
    return {
        message: Message.UPLOAD,
        token,
    };
}


const MakeConfigMessage = (url) => {
    return {
        message: Message.CONFIG,
        url,
    };
}
